/**
 * Motivate different types of swal modal popups.
 *
 */
import Swal from 'sweetalert2';

export const modalSwal = () => {
	document.querySelectorAll( '.swal-cta' ).forEach( ( button ) => {
		button.addEventListener( 'click', buttonEventHander );
	} );
};

const buttonEventHander = ( event ) => {
	const button = event.target.closest( '.swal-cta' );
	const targetElement = document.getElementById( button.dataset.target );
	if ( ! targetElement ) {
		return;
	}

	event.preventDefault();

	Swal.fire( {
		html: targetElement.innerHTML,
		showCloseButton: true,
		showConfirmButton: false,
		grow: 'fullscreen',
		background: '#000',
		color: '#fff',
		customClass: 'c-modal__swal',
	} );
};
